import {
    Table,
    Row,
    Column,
    TextWithMargin,
    Market,
    BuyIcon,
    SellIcon,
    TableWrapper,
    OrdersBody
} from "../../styles/OrdersStyle";
import { FlexCenter } from "../../styles/CommonStyles";
import { AnimatePresence } from "framer-motion";
import { formatDate, formatNumber, variants } from "../../utils/common";
import FilterLayout from "../../layouts/FilterLayout";
import { useMainContext } from "../../contexts/main";
import Text from "../../utils/Text";
import { SOCKET_URL } from "../../constants/urls";
import {useOrdersHistory} from "../../hooks/useOrdersHook";
import {useProfileQuery} from "../../services/react-query/useProfileQuery";



const History = () => {

    const { main: { lang } } = useMainContext()
    const { data: profile } = useProfileQuery()

    const {
        orders, allPages,
        filterQueries, setFilterQueries,
        initialState, isFetching
    } = useOrdersHistory()

    return (
        <OrdersBody>
            <FilterLayout
                headers={headers}
                data={orders}
                totalPages={allPages}
                state={{ filterQueries, setFilterQueries, initialState }}
                loading={isFetching}
                hasCoinOption
                hasTypeOptions
            >
                <AnimatePresence exitBeforeEnter>
                    <TableWrapper height="230px" variants={variants} initial="out" animate="in" exit="out" >
                        <Table width="100%">
                            {profile && orders?.data?.map((item, index) => {
                                let transactionType;
                                if (profile._id === item.order.userId) {
                                    transactionType = item.order.type
                                }else {
                                    transactionType = item.order.type === "buy" ? "sell" : "buy"
                                }
                                return (
                                    <Row key={item.date}>
                                        <Column width="14.2%">
                                            <FlexCenter>
                                                <img
                                                    src={
                                                        SOCKET_URL +
                                                        `assets/icon/${item?.order.coin}.png`
                                                    }
                                                    alt=" "
                                                    width="18px" height="18px"
                                                />
                                                <Market>{`${item.order.coin?.toUpperCase()}/${item.pair?.toUpperCase()}`}</Market>
                                            </FlexCenter>
                                        </Column>
                                        <Column width="14.2%" number>{formatNumber(item.amount)}</Column>
                                        <Column width="14.2%" number>{formatNumber(item.priceUnit)}</Column>
                                        <Column width="14.2%" number>{formatNumber(item.price)}</Column>
                                        <Column width="14.2%">
                                            <FlexCenter>
                                                {transactionType === "buy" ?
                                                    <BuyIcon />
                                                    :
                                                    <SellIcon />
                                                }
                                                <TextWithMargin type={transactionType}>
                                                    <Text tid={transactionType} />
                                                </TextWithMargin>
                                            </FlexCenter>
                                        </Column>
                                        <Column width="14.2%" number>
                                            {formatDate(
                                                item.createdAt ? item.createdAt : item.order.createdAt,
                                                "date",
                                                lang === "en" ? "en-US" : "fa-IR"
                                            )}
                                        </Column>
                                        <Column width="14.2%" number>
                                            {formatDate(
                                                item.createdAt ? item.createdAt : item.order.createdAt,
                                                "time",
                                                lang === "en" ? "en-US" : "fa-IR"
                                            )}
                                        </Column>
                                    </Row>
                                );
                            })}
                        </Table>
                    </TableWrapper>
                </AnimatePresence>
            </FilterLayout>
        </OrdersBody>
    );
};

const headers = [
    { title: "market", width: "14.2%" },
    { title: "amount", width: "14.2%" },
    { title: "unitPrice", width: "14.2%" },
    { title: "totalPrice", width: "14.2%" },
    { title: "transactionType", width: "14.2%" },
    { title: "date", width: "14.2%" },
    { title: "timeHour", width: "14.2%" },
]


export default History;
